import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-session/auth.guard';
import { PublicLayoutComponent } from './components/public-layout/public-layout.component';
import { PublicHomeComponent } from './components/public-home/public-home.component';
import { CourseListComponent } from './components/course-list/course-list.component';
import { CourseDetailComponent } from './components/course-detail/course-detail.component';
import { CartComponent } from './components/cart/cart.component';
import { CustomerLoginComponent } from './components/customer-login/customer-login.component';
import { CustomerRegisterComponent } from './components/customer-register/customer-register.component';
import { CustomerLayoutComponent } from './components/customer-layout/customer-layout.component';
import { CustomerDashboardComponent } from './components/customer-dashboard/customer-dashboard.component';
import { CustomerProfileComponent } from './components/customer-profile/customer-profile.component';
import { CustomerPurchasesComponent } from './components/customer-purchases/customer-purchases.component';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';
import { AdminCoursesComponent } from './components/admin-courses/admin-courses.component';
import { AdminTagsComponent } from './components/admin-tags/admin-tags.component';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { AdminCustomersComponent } from './components/admin-customers/admin-customers.component';
import { AdminOrdersComponent } from './components/admin-orders/admin-orders.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { BookingConfirmationComponent } from './components/booking-confirmation/booking-confirmation.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { TrainingComponent } from './components/training/training.component';
import { NewCourseListComponent } from './components/new-course-list/new-course-list.component';
import { VocCourseComponent } from './components/voc-course/voc-course.component';
import { AdminVOCComponent } from './components/admin-voc/admin-voc.component';
import { VOCPaymentComponent } from './components/vocpayment/vocpayment.component';
import { AdminShortCourseOrdersComponent } from './components/admin-short-course-orders/admin-short-course-orders.component';
import { AdminVocCourseDetailComponent } from './components/admin-voc-course-detail/admin-voc-course-detail.component';
import { XCoursesListComponent } from './components/x-courses-list/x-courses-list.component';
import { XCourseCalendarComponent } from './components/x-course-calendar/x-course-calendar.component';
import { AdminXEnquiriesComponentComponent } from './components/admin-xenquiries-component/admin-xenquiries-component.component';
import { AdminXbookingsComponent } from './components/admin-xbookings/admin-xbookings.component';
import { VocCompanyFormComponent } from './components/voc-company-form/voc-company-form.component';
import { XPaidRegistrationComponent } from './components/x-paid-registration/x-paid-registration.component';
import { XCourseMultiFormComponent } from './components/x-course-multi-form/x-course-multi-form.component';
import { GtoComponent } from './components/gto/gto.component';
import { BreakingTheCycleComponent } from './components/breaking-the-cycle/breaking-the-cycle.component';
import { HsrTrainingComponent } from './components/hsr-training/hsr-training.component';
import { XShortCourseListComponent } from './components/x-short-course-list/x-short-course-list.component';
import { XShortCourseDetailsComponent } from './components/x-short-course-details/x-short-course-details.component';
import { XSingleEnquireComponent } from './components/x-single-enquire/x-single-enquire.component';
import { AdminShortCoursesComponent } from './components/admin-short-courses/admin-short-courses.component';
import { XParticipantRegistrationComponent } from './components/x-participant-registration/x-participant-registration.component';
import { CorporateComponent } from './components/corporate/corporate.component';
import { XHsrCoursesComponent } from './components/x-hsr-courses/x-hsr-courses.component';
import { ManualSyncComponent } from './components/manual-sync/manual-sync.component';
import { XVocListComponent } from './components/x-voc-list/x-voc-list.component';



// Route list.
const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: PublicHomeComponent },
      { path: 'course-qualifications', component: CourseListComponent },
      { path: 'courses/:id', component: CourseDetailComponent },
      { path: 'about-us', component: AboutUsComponent },
      { path: 'contact-us', component: ContactUsComponent },
      { path: 'cart', component: CartComponent },
      { path: 'booking', redirectTo: 'cart', pathMatch: 'full' },
      { path: 'booking/:id', redirectTo: 'cart' },
      { path: 'auth/customer-login', component: CustomerLoginComponent },
      { path: 'auth/register', component: CustomerRegisterComponent },
      { path: 'payment-success', component: BookingConfirmationComponent },
      { path: 'training', component: TrainingComponent },
      { path: 'gto', component: GtoComponent },
      { path: 'breaking-the-cycle', component: BreakingTheCycleComponent },
      { path: 'community-services', component: BreakingTheCycleComponent },
      { path: 'hsr-training', component: HsrTrainingComponent },
      { path: 'course-calendar', component: XCourseCalendarComponent },
      { path: 'course-voc', component: VocCourseComponent },
      { path: 'vocPay', component: VOCPaymentComponent },
      { path: 'course-booking', component: XCoursesListComponent },
      { path: 'corporate', component: CorporateComponent },
      { path: 'voc-registration', component: VocCompanyFormComponent },
      { path: 'paid-registration', component: XPaidRegistrationComponent },
      { path: 'corporate-form', component: XCourseMultiFormComponent },
      { path: 'course-short', component: XShortCourseListComponent },
      { path: 'short-details', component: XShortCourseDetailsComponent },
      { path: 'single-enquire', component: XSingleEnquireComponent },
      { path: 'participant-registration', component: XParticipantRegistrationComponent },
      { path: 'course-hsr', component: XHsrCoursesComponent }
     
    ]
  },
  {
    path: 'customer',
    component: CustomerLayoutComponent,
    canActivate: [AuthGuard],
    data: { roleCode: 'CUSTOMER' },
    children: [
      { path: 'dashboard', component: CustomerDashboardComponent },
      { path: 'profile', component: CustomerProfileComponent },
      { path: 'purchases', component: CustomerPurchasesComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: 'admin/login', component: AdminLoginComponent },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    data: { roleCode: 'ADMIN' },
    children: [
      { path: 'dashboard', component: AdminDashboardComponent },
      { path: 'courses', component: AdminCoursesComponent },
      { path: 'tags', component: AdminTagsComponent },
      { path: 'admin-users', component: AdminUsersComponent },
      { path: 'customers', component: AdminCustomersComponent },
      { path: 'orders', component: AdminOrdersComponent },
      { path: 'vocRequests', component: AdminVOCComponent },
      { path: 'shortCourseOrders', component: AdminShortCourseOrdersComponent },
      { path: 'vocPublicCourses', component: AdminVocCourseDetailComponent },
      { path: 'enquiriesList', component: AdminXEnquiriesComponentComponent },
      { path: 'bookingsList', component: AdminXbookingsComponent },
      { path: 'shortCourses', component: AdminShortCoursesComponent },
      { path: 'manualSync', component: ManualSyncComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', component: NotFoundComponent }
];

// Routing module.
@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled', useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }